import { render } from "./LayoutGenerator.vue?vue&type=template&id=2b1faea4"
import script from "./LayoutGenerator.vue?vue&type=script&lang=js"
export * from "./LayoutGenerator.vue?vue&type=script&lang=js"

import "./LayoutGenerator.vue?vue&type=style&index=0&id=2b1faea4&lang=scss"
script.render = render

export default script